var moment = require('moment');
var apiDataConstants = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/apiDataConstants.js');

var setStepDataFromApi = function (step, apiResponseKey, data) {
    var productInfo = (data) => {
        if (data) {
            //console.log('rateType ' + data.MembershipRateStructure);
            //console.log('rateCode ' + data.MembershipRateCode);
            //console.log('membershipPrice ' + data.MembershipPrice);
            this.updateApplicationState('membershipPrice', data.MembershipPrice);
            this.updateApplicationState('stateParticipating', data.StateParticipating);
            this.updateApplicationState('stateComponentDues', data.ChapterPrice);
            this.updateApplicationState('stateComponentDuesOptOutEligible', data.OptOutEligible);
            this.updateApplicationState('districtDues', data.DistrictPrice);
            this.updateApplicationState('districtParticipating', data.DistrictParticipating);
            this.updateApplicationState('districtProductTitle', data.DistrictProductTitleLongName);
            
            this.updateApplicationState('membershipProductTitle', data.MemberProductTitleLongName);
            this.updateApplicationState('productId', data.MembershipProductId);

            this.updateApplicationState('rateType', data.MembershipRateStructure);
            this.updateApplicationState('rateCode', data.MembershipRateCode);
            this.updateApplicationState('membershipPrice', data.MembershipPrice);
            this.updateApplicationState('membershipProductTitleLongName', data.MembershipProductTitleLongName);
            this.updateApplicationState('membershipStartDate',
                data.MembershipStartDateTime ? moment.utc(data.MembershipStartDateTime).format('YYYY-MM-DD') : '');
            this.updateApplicationState('membershipEndDate',
                data.MembershipEndDateTime ? moment.utc(data.MembershipEndDateTime).format('YYYY-MM-DD') : '');
        }
    };

    var contactInfo = (data) => {
        if (data && data.length) {
            var address = data.filter((address) => {
                return address.ShipToFlag;
            });

            address = address && address.length ? address[0] : data[0];

            this.updateArbitraryStepState('addressLine1', address.Address1, 3);
            this.updateArbitraryStepState('addressLine2', address.Address2, 3);
            this.updateArbitraryStepState('addressLine3', address.Address3, 3);
            this.updateArbitraryStepState('addressLine4', address.Address4, 3);

            this.updateArbitraryStepState('addressId', address.AddressId, 3);
            this.updateArbitraryStepState('addressStatus', address.AddressStatus, 3);
            this.updateArbitraryStepState('step3AddressType', address.AddressType, 6); // step 6 looks at the address type already chosen in step 3
            this.updateArbitraryStepState('city', address.City, 3);
            this.updateArbitraryStepState('state', address.State, 3);
            this.updateArbitraryStepState('zip', address.PostalCode, 3);
            this.updateArbitraryStepState('companyName', address.CompanyName, 3);

            if (address.AddressType !== 'BLANK') {
                this.updateArbitraryStepState('country', address.CountryCode, 3);
                this.updateArbitraryStepState('addressType', address.AddressType, 3);
            }

            this.updateArbitraryStepState('addressStatus', address.AddressStatus, 3);
            this.updateArbitraryStepState('billToFlag', address.BillToFlag, 3);
            this.updateArbitraryStepState('formattedAddress', address.FormattedAddress, 3);
            this.updateArbitraryStepState('isPrimaryAddress', address.IsPrimary, 3);
            this.updateArbitraryStepState('shipToFlag', address.ShipToFlag, 3);
        }
    }

    var resolveFunctions = {
        2: {
            'CustomerInformation': (data) => {
                if (data && data.length) {
                    this.updateArbitraryStepState('firstName', data[0].FirstName, step);
                    this.updateArbitraryStepState('middleName', data[0].MiddleName, step);
                    this.updateArbitraryStepState('lastName', data[0].LastName, step);
                    this.updateArbitraryStepState('prefix', data[0].NamePrefix, step);
                    this.updateArbitraryStepState('suffix', data[0].NameSuffix, step);
                    this.updateArbitraryStepState('credentials', data[0].CredentialsList, step);
                    this.updateArbitraryStepState('email', data[0].EmailAddress, step);
                    this.updateArbitraryStepState('primaryPracticeLocation', data[0].PrimaryPracticeLocation, step);
                    this.updateArbitraryStepState('primaryDistrictLocation', data[0].DistrictCode, step);
                    this.updateArbitraryStepState('yearsInPractice', data[0].YearsInPractice, step);
                }
            }
        },
        3: {
            'GovernmentSector': (data) => {
                if (data && data.length) {
                    this.updateArbitraryStepState('governmentSector', data[0].SubDemographic, step);
                    this.updateArbitraryStepState('governmentSectorId', data[0].CusDemographicId, step);
                    this.updateArbitraryStepState('governmentSectorIdToDelete', '', step);
                }
            },
            'MilitaryService': (data) => {
                if (data && data.length) {
                    this.updateArbitraryStepState('branch', data[0].SubDemographic, step);
                    this.updateArbitraryStepState('branchId', data[0].CusDemographicId, step);
                    this.updateArbitraryStepState('branchIdToDelete', '', step);
                }
            },
            'Demographics': (data) => {
                if (data) {
                    this.updateArbitraryStepState('gender', data.Gender, step);
                    this.updateArbitraryStepState('ethnicity', data.Ethnicity, step);
                    this.updateArbitraryStepState('race', data.Race, step);
                    this.updateArbitraryStepState('birthdate', data.Birthdate, step);
                }
            },
            'AddressInformation': contactInfo,
            '_Customerphones': (data) => {
                if (data && data.length) {
                   var phone = data[0];

                    this.updateArbitraryStepState('phoneNumber', phone.PhoneNumber, step);
                    this.updateArbitraryStepState('phoneLocation', phone.PhoneLocation, step);
                    this.updateArbitraryStepState('includeInMemberDirectory', phone.IncludeinMemberDirectory, step);
                }
            },
            'ProductInfo': productInfo
        },
        4: {
            'CustomerInformation': (data) => {
                if (data && data.length) {
                    var info = data[0];

                    if (info.PrimaryPracticeLocation) {
                        this.updateArbitraryStepState('primaryPracticeLocation', info.PrimaryPracticeLocation, step);
                    }
                    if (info.DistrictCode) {
                        this.updateArbitraryStepState('primaryDistrictLocation', info.DistrictCode, step);
                    }
                    this.updateArbitraryStepState('npiNumber', info.NpiNumber ? info.NpiNumber.toString() : '', step);
                    this.updateArbitraryStepState('yearsInPractice', info.YearsInPractice, step);
                }
            },
            'MedicalLicensures': (data) => {
                if (data && data.length) {
                    var licenses = [];

                    data.map((license) => {
                        licenses.push({
                            id: license.LicenseId,
                            entityGuid: license.EntityGUID,
                            state: license.State,
                            startDate: license.BeginDate ? moment.utc(license.BeginDate).format('YYYY-MM-DD') : '',
                            expireDate: license.EndDate && moment.utc(license.EndDate).format('YYYY-MM-DD') !== "0001-01-01" ? moment.utc(license.EndDate).format('YYYY-MM-DD') : '',
                            fromApi: true
                        });
                    });

                    this.updateArbitraryStepState('activeLicenses', licenses, step);
                }
            },
            '_Certifications': (data) => {
                if (data && data.length) {
                    // First look for the primary board certification ABA_ID or AOBA_ID
                    var boardLabel = '';
                    var board = data.filter(
                        (data) => {
                            if (data.SubDemographic === apiDataConstants.boardCertificationCodes.aba) {
                                boardLabel = 'ABA';
                                return true;
                            }

                            if (data.SubDemographic === apiDataConstants.boardCertificationCodes.aoba) {
                                boardLabel = 'AOBA';
                                return true;
                            }
                        });

                    if (board && board.length) {
                        board = board[0];
                        this.updateArbitraryStepState('boardCertification', boardLabel, step);
                        this.updateArbitraryStepState('boardCertificationId', board.CusDemographicId, step);
                        this.updateArbitraryStepState('boardCertificationNumber', board.Number, step);
                        this.updateArbitraryStepState('boardCertificationDate', board.BeginDate ? moment.utc(board.BeginDate).format('YYYY-MM-DD') : '', step);
                    } else {
                        this.updateArbitraryStepState('boardCertification', 'Not Certified', step);
                    }

                    // Get any other subboards
                    var subboards = data.filter((data) => data.SubDemographic !== apiDataConstants.boardCertificationCodes.aba && data.SubDemographic !== apiDataConstants.boardCertificationCodes.aoba);
                    this.updateArbitraryStepState('boardSubSpecialties', subboards, step);
                    this.updateArbitraryStepState('hasBoardSubSpecialty', subboards.length > 0, step);
                } else {
                    this.updateArbitraryStepState('boardCertification', 'Not Certified', step);
                }
            },
            'ProductInfo': productInfo
        },
        5: {
            'CustomerEducationInfo': (data) => {
                var medSchool = data.filter((item) => {
                    return item.ProgTypeCodeString === apiDataConstants.programTypeCodes.medSchool || item.ProgTypeCodeString === apiDataConstants.programTypeCodes.training;
                });

                if (medSchool && medSchool.length) {
                    var school = medSchool[0];
                    this.updateArbitraryStepState('medSchoolCountry', school.UserDefinedCountryCodeString, step);
                    this.updateArbitraryStepState('medSchoolState', school.UserDefinedState, step);
                    this.updateArbitraryStepState('medSchoolInstitution', school.InstitutionName, step);
                    this.updateArbitraryStepState('medSchoolStartDate', school.BeginDate ? moment.utc(school.BeginDate).format('YYYY-MM-DD') : '', step);
                    this.updateArbitraryStepState('medSchoolEndDate', school.EndDate ? moment.utc(school.EndDate).format('YYYY-MM-DD') : '', step);
                    this.updateArbitraryStepState('medSchoolCustomerEducationId', school.CustomerEducationId, step);
                }

                var residency = data.filter((item) => {
                    return item.ProgTypeCodeString === apiDataConstants.programTypeCodes.residency;
                });

                if (residency && residency.length) {
                    var residence = residency[0];
                    this.updateArbitraryStepState('residencyCountry', residence.UserDefinedCountryCodeString, step);
                    this.updateArbitraryStepState('residencyState', residence.UserDefinedState, step);
                    this.updateArbitraryStepState('residencyInstitution', residence.InstitutionName, step);
                    this.updateArbitraryStepState('residencyProgramDegreeCodeString', residence.ProgramDegreeCodeString, step);
                    this.updateArbitraryStepState('residencyStartDate', residence.BeginDate ? moment.utc(residence.BeginDate).format('YYYY-MM-DD') : '', step);
                    this.updateArbitraryStepState('residencyEndDate', residence.EndDate ? moment.utc(residence.EndDate).format('YYYY-MM-DD') : '', step);
                    this.updateArbitraryStepState('residencyCustomerEducationId', residence.CustomerEducationId, step);
                }

                var fellowships = data.filter((item) => {
                    return item.ProgTypeCodeString === apiDataConstants.programTypeCodes.fellowship;
                });

                if (fellowships && fellowships.length) {
                    var fellowshipsList = [];

                    fellowships.map((item) => {
                        fellowshipsList.push({
                            id: item.CustomerEducationId,
                            country: item.UserDefinedCountryCodeString,
                            state: item.UserDefinedState,
                            institution: item.InstitutionName,
                            programType: item.ProgTypeCodeString,
                            type: item.UserDefinedFellowshipCodeString,
                            programDegreeCodeString: item.ProgramDegreeCodeString,
                            subtype: item.UserDefinedFellowshipSubcodeString,
                            startDate: item.BeginDate ? moment.utc(item.BeginDate).format('YYYY-MM-DD') : '',
                            endDate: item.EndDate ? moment.utc(item.EndDate).format('YYYY-MM-DD') : '',
                            entityGuid: item.EntityGUID,
                            customerEducationId: item.CustomerEducationId,
                            fromApi: true
                        });
                    });

                    this.updateArbitraryStepState('fellowships', fellowshipsList, step);
                }
            },
            'ProductInfo': productInfo              
},
6: {
    'CustomerInformation': (data) => {
        if (data && data.length) {
            var info = data[0];
            this.updateArbitraryStepState('yearsInPractice', info.YearsInPractice, step);
            this.updateApplicationState('yearsInPractice', info.YearsInPractice);

        }
    },
        'ProductInfo': productInfo,

            'AddressInformation': contactInfo,
                'CustomerEducationInfo': (data) => {
                    var medSchool = data.filter((item) => {
                        return item.ProgTypeCodeString === apiDataConstants.programTypeCodes.medSchool || item.ProgTypeCodeString === apiDataConstants.programTypeCodes.training;
                    });

                    if (medSchool && medSchool.length) {
                        var school = medSchool[0];
                        this.updateArbitraryStepState('medSchoolCountry', school.UserDefinedCountryCodeString, 5);
                        this.updateArbitraryStepState('medSchoolState', school.UserDefinedState, 5);
                        this.updateArbitraryStepState('medSchoolInstitution', school.InstitutionName, 5);
                        this.updateArbitraryStepState('medSchoolStartDate', school.BeginDate ? moment.utc(school.BeginDate).format('YYYY-MM-DD') : '', 5);
                        this.updateArbitraryStepState('medSchoolEndDate', school.EndDate ? moment.utc(school.EndDate).format('YYYY-MM-DD') : '', 5);
                        this.updateArbitraryStepState('medSchoolCustomerEducationId', school.CustomerEducationId, 5);
                    }

                    var residency = data.filter((item) => {
                        return item.ProgTypeCodeString === apiDataConstants.programTypeCodes.residency;
                    });

                    if (residency && residency.length) {
                        var residence = residency[0];
                        this.updateArbitraryStepState('residencyCountry', residence.UserDefinedCountryCodeString, 5);
                        this.updateArbitraryStepState('residencyState', residence.UserDefinedState, 5);
                        this.updateArbitraryStepState('residencyInstitution', residence.InstitutionName, 5);
                        this.updateArbitraryStepState('residencyProgramDegreeCodeString', residence.ProgramDegreeCodeString, 5);
                        this.updateArbitraryStepState('residencyStartDate', residence.BeginDate ? moment.utc(residence.BeginDate).format('YYYY-MM-DD') : '', 5);
                        this.updateArbitraryStepState('residencyEndDate', residence.EndDate ? moment.utc(residence.EndDate).format('YYYY-MM-DD') : '', 5);
                        this.updateArbitraryStepState('residencyCustomerEducationId', residence.CustomerEducationId, 5);
                    }

                    var fellowships = data.filter((item) => {
                        return item.ProgTypeCodeString === apiDataConstants.programTypeCodes.fellowship;
                    });

                    if (fellowships && fellowships.length) {
                        var fellowshipsList = [];

                        fellowships.map((item) => {
                            fellowshipsList.push({
                                id: item.CustomerEducationId,
                                country: item.UserDefinedCountryCodeString,
                                state: item.UserDefinedState,
                                institution: item.InstitutionName,
                                programType: item.ProgTypeCodeString,
                                type: item.UserDefinedFellowshipCodeString,
                                programDegreeCodeString: item.ProgramDegreeCodeString,
                                subtype: item.UserDefinedFellowshipSubcodeString,
                                startDate: item.BeginDate ? moment.utc(item.BeginDate).format('YYYY-MM-DD') : '',
                                endDate: item.EndDate ? moment.utc(item.EndDate).format('YYYY-MM-DD') : '',
                                entityGuid: item.EntityGUID,
                                customerEducationId: item.CustomerEducationId,
                                fromApi: true
                            });
                        });

                        this.updateArbitraryStepState('fellowships', fellowshipsList, 5);
                    }
                }
}
    }

    return resolveFunctions[step][apiResponseKey](data);
}

module.exports = {
    setStepDataFromApi: setStepDataFromApi
};
